import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'
//import { no167Style } from '../../../components/Article/No167.style'
import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '自分らしくにいがたで輝く | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="特集" />
      <SectionTitle sectionTitle="自分らしくにいがたで輝く" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2024夏号 No.167 目次",
              path: "/no167"
            },
            {
              name: "特集"
            }
          ]}
        />
        
        <div>
        <img
          src={`${basePath}/no167/img/1-1.png`}
          alt="新潟を支えるために／守るために／癒すために／繋ぐために"
          css={style.img(0)}
        />
        </div>
        
        
        <h3 css={style.subTitle01}>誰もが活躍できる新潟県へ</h3>
        
        <img
          src={`${basePath}/no167/img/1-2.png`}
          alt="新潟県知事　花角英世"
          css={style.img(250)}
        />
        
        <p>新潟県知事&emsp;花角英世</p>
        
        <p>本格的な夏の到来を迎えます。気温が上昇し、熱中症のリスクが高まることから、県民の皆様におかれましては、こまめな水分・塩分補給にご留意の上、健康で安全に夏をお楽しみいただきたいと思います。<br />さて、全国と同様、新潟県においても、少子化や若年層の流出などによる人口減少を背景に、幅広い分野で人手不足の状況が続いており、事業活動の制約要因となっています。本県産業の更なる成長・発展のため、各分野における人材の育成・確保や、生産性の向上に取り組む必要があります。<br />そのため県では、企業や労働者の皆様のニーズを把握しながら、年齢、障害の有無、性別、国籍等に関わらず活躍できる環境づくりなど、地域の産業を支える人材の確保に向けた様々な施策を実施しております。その一環として、U・Iターンの促進をはじめ、外国人材の受入サポートや新潟県地域おこし協力隊の受入拡大などの取組により、新潟への移住を希望する方々を支援し、応援しています。<br />県外で培ってきたキャリアやスキルを新潟県で活かしていただけることは、大変喜ばしいことです。誰もが皆、多様で自分らしい生き方、働き方を実現できる場としての「選ばれる新潟」を目指してまいります。</p>
        
        
        <h3 css={style.subTitle01}>新しい人生を、にいがたで切り拓く</h3>
        
        <p>県外から新潟へ移住し、自分らしい生き方、働き方をして輝いている人たちをクローズアップし、新しい生活をスタートした経緯と心境を紹介します。<br />新潟県では、U・Iターン促進、外国人材受入サポート、新潟県地域おこし協力隊などの取組を通じ、新潟へ移住し、暮らしたい方々を支援し、応援しています。</p>
        
        
        <h4 css={style.subTitle02}>【支える】東京からU・Iターン<br />仕事と子育ての両立に迷い夫婦でU・Iターンを決意</h4>
        
        <p><span css={style.emphasisWeight}>株式会社Pepo&ensp;木村愛子さん（新潟市出身）&ensp;木村正幸さん（東京都出身）</span></p>
        
        <img
          src={`${basePath}/no167/img/2-1.png`}
          alt="新潟の魅力！ちょうどいい都会と田舎"
          css={style.img(300)}
        />
        
        <p>2020年に新潟市へU・Iターンし、夫婦で起業しました。社内システムの開発・提供を行っていて、前職の会社からサポートを受けながらの独立でした。都会に憧れて東京へ出たので戻るつもりはなかったのですが、結婚、出産を経て、東京で子育てしながら働く大変さを実感。戻りたい気持ちが大きくなり、東京出身の夫も新潟を気に入ってくれていたので、新潟で一緒に会社をやろうと誘い、夫婦で決断しました。<br />起業までは新潟IPC財団に相談したり、SNSで情報を集めたりしながら人脈を広げていきました。新潟は「こういうことをやってみたい」と発信すると、興味を持った人がすぐ集まってきてくれます。新しいことをやる人が目立ちやすいし、キーパーソンに繋がりやすいのが面白い。今は複数の事業者で共同オフィスを作る計画を進めています。家や車などの住環境が充実してストレスなく暮らせていますし、子どもたちものびのび遊べていて、帰ってきてよかったと思っています。</p>
        
        <img
          src={`${basePath}/no167/img/2-2.png`}
          alt="仕事と子育てについては、常に二人で相談しながら分担している"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>仕事と子育てについては、常に二人で相談しながら分担している</p>
        
        <h5 css={style.subTitle03}>応援VOICE</h5>
        <p>起業家として活躍する木村さんご夫婦。新潟に新しい風を吹かせてくれ、勇気をもらいます。子育てと会社を切り盛りすることは大変だけど、いつも笑顔な姿が最高。<br />
        佐藤正恵（パジュ・ブレーン株式会社）</p>

        <h5 css={style.subTitle03}>U・Iターン支援</h5>
        <p>社会人から学生まで、新潟県へのU・Iターンをサポートします</p>
        
        <p>【問い合わせ】しごと定住促進課&emsp;電話：<a href="tel:025-280-5635">025-280-5635</a></p>
        <br />
        
        
        <h4 css={style.subTitle02}>【繋ぐ】外国人材<br />TOEIC満点の語学力をいかして日本と海外の架け橋に</h4>
        
        <p><span css={style.emphasisWeight}>株式会社W＆N&ensp;オスマン・ノルハフィザ・ハヤティさん （ブルネイ出身）</span></p>
        
        <img
          src={`${basePath}/no167/img/3-1.png`}
          alt="新潟の魅力！海鮮丼美味しい"
          css={style.img(300)}
        />
        
        <p>日本語を勉強したくて2022年に来日して、1年間長野県の日本語学校に通いました。卒業後は、帰国、進学、就職の選択肢がありましたが、英語が話せる人材を探しているという三条市の機械商社、株式会社W&Nを紹介され、得意な英語力を活かせると思い入社しました。所属している貿易部では、海外製の機械や部品の調達、営業部•サービス部のサポートなどを担当しています。機械や貿易の専門知識をーから勉強することは大変でしたが、仲間と一緒に楽しく仕事をしています。現在会社には外国籍の社員が3人いて、これからも増えていく予定です。<br />三条市は、山もあって、海も近く、ブルネイと似ていていいところだと思います。今後、社屋を開放して、地域の子どもたち向けに無料で英会話教室を行うことを計画しています。私は母国では保育士だったので、ぜひ参加して楽しい時間を作っていきたいと思っています。</p>
        
        <img
          src={`${basePath}/no167/img/3-2.png`}
          alt="オスマンさんの明るい人柄で、職場はいつも笑顔であふれている"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>オスマンさんの明るい人柄で、職場はいつも笑顔であふれている</p>
        
        <h5 css={style.subTitle03}>応援VOICE</h5>
        <p>今や会社になくてはならない存在で、ブルネイから約4千㎞離れた新潟に来てくれたことに改めて感謝します。計画中の地域交流教室でも活躍を期待しています。<br />
        競みづき（株式会社W&N）</p>

        <h5 css={style.subTitle03}>外国人材の受け入れ</h5>
        <p>検討の段階から実務的な採用フロー、手続きまでお手伝いします</p>
        
        <p>【問い合わせ】外国人材受入サポートセンター&emsp;電話：<a href="tel:025-250-1021">025-250-1021</a></p>
        <br />
        
        <h4 css={style.subTitle02}>【守る】新潟県地域おこし協力隊<br />鳥獣被害から県民を守りたい</h4>
        
        <p><span css={style.emphasisWeight}>新潟県地域おこし協力隊（ニイガタコラボレーターズ）<br />鈴木暁慈朗さん（埼玉県出身）</span></p>
        
        <img
          src={`${basePath}/no167/img/2-3.png`}
          alt="新潟の魅力！自然の鮮度を感じるところ！"
          css={style.img(300)}
        />
        
        <p>「人を守る・救う」仕事をしたいと思い、自分にできることを探していたときに、新潟県の地域おこし協力隊の募集を知りました。惹かれたのは鳥獣被害対策という言葉で、動物に農地を荒らされて困っている地域の皆さんの力になりたいと感じました。2022年に着任し、活動支援会社で専門知識を学びながら、時期になるとワナをしかけたり、動物侵入対策の電気柵を設けたりするほか、被害発生地域からの相談にのったりしています。<br />山での作業は、最初は付いて歩くのに精一杯でしたが、今では、けものみちや足跡を見つけられるまでになりました。また、地域の皆さんも温かく受け入れてくださって、ありがたく思っています。協力隊のメンバー同士のコミュニティも生まれ、夢や目標を語り合うのも楽しいです。将来的には、鳥獣被害対策のプロフェッショナルとして、一緒に取り組む仲間を増やして、地域の力になっていけたらと思っています。</p>
        
        <img
          src={`${basePath}/no167/img/2-4.png`}
          alt="「ケモノ展」（2023年）で、来場者の皆さんへ分かりやすく解説"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>「ケモノ展」（2023年）で、来場者の皆さんへ分かりやすく解説</p>
        
        <h5 css={style.subTitle03}>応援VOICE</h5>
        <p>鳥獣被害対策の知識や捕獲技術を次々と習得している姿は非常に頼もしいです。今後は専門家として、多くの担い手を育成するために、一緒に頑張りましょう。<br />
        県農産園芸課 生産環境係</p>

        <br />
        
        <h4 css={style.subTitle02}>【癒す】新潟県地域おこし協力隊<br />雪国リトリートの魅力を広めていきたい</h4>
        
        <p><span css={style.emphasisWeight}>新潟県地域おこし協力隊（ニイガタコラボレーターズ）<br />石井佳穂さん（東京都出身）</span></p>
        
        <img
          src={`${basePath}/no167/img/3-3.png`}
          alt="新潟の魅力！「生きている」と実感できる場所"
          css={style.img(300)}
        />
        
        <p>「リトリート」とは、日常から離れて、自分が癒される場所でゆっくり過ごして心と体を休める、というもの。これと雪国の地域資源を有効活用し、組み合わせたのが「雪国リトリート」です。2023年から事業のサポート役として湯沢町を拠点に着任し、現在は、30-40代の女性やインバウンド客をターゲットにした旅行プラン作成のお手伝いや販売PRなどを担当しています。<br />大学で観光学を専攻するなかで、美味しい物を食べたり、綺麗な景色を見たりする行楽を目的とした観光ではなく、「学びや気づきがある観光のあり方」に興味を持ち、新卒で新潟へ来ることを決めました。ご近所さんから山菜や野菜をいただいたり、地域の歴史や文化を学んでいくうちに、湯沢への愛着が芽生えてきて、楽しい新潟ライフを送っています。特に大源太キャニオンは、私のリトリートスポットになりつつあります。学生をターゲットにしたプランの提案を目標に、今後も事業を通して新潟県に貢献していきたいです。</p>
        
        <img
          src={`${basePath}/no167/img/3-4.png`}
          alt="越後湯沢の大源太で、地元の方と観光プランについて打ち合わせ"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>越後湯沢の大源太で、地元の方と観光プランについて打ち合わせ</p>
        
        <h5 css={style.subTitle03}>応援VOICE</h5>
        <p>各方面との信頼関係を深め、雪国リトリートの定着に向け、日々試行錯誤を重ねる姿はとても心強いです。これからも豊かな発想で魅力発信していただきたいです！<br />
        南魚沼地域振興局 企画振興部</p>
        
        <h5 css={style.subTitle03}>新潟県地域おこし協力隊（ニイガタコラボレーターズ）とは？</h5>
        <p>地域おこし協力隊は、都市部から条件不利地域などに移住し、1年から3年の間、地域協力活動を行いながら、その地域への定住を図る取組です。これまで市町村での活用が進んでいましたが、令和4年度から県でも「ニイガタコラボレーターズ」と称して導入し、今回紹介した農業、観光業のほか、水産業、福祉、教育など様々な分野で、計12名（※7月1日現在）の隊員が活躍しています。</p>
        
        <p>【問い合わせ】地域政策課 地域づくり支援班&emsp;電話：<a href="tel:025-280-5095">025-280-5095</a></p>

        <BackBtn href={"/no167"} />
      </Content>
    </Page>
  )
}
export default Home
